module.exports = {
      id: "angle-right-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#angle-right",
      toString: function () {
        return this.url;
      }
    }